﻿import { Element as RustigElement } from '../utilities/element';

export class MathExpressions {
  public static wireup() {

    let getValue = (element: HTMLElement): any => {
      var rElement = RustigElement.from(element);

      let result = element.getAttribute('data-expression-value')
        || rElement.value()
        || 0;

      if (rElement.isCheckbox) {
        let isChecked = !!rElement.value();
        return isChecked ? Number(result) : 0;
      }

      return result;
    }

    let setValue = (element: HTMLElement, value: any): void => {
      let rElement = RustigElement.from(element);
      let setType = element.getAttribute('data-expression-set') || 'value';

      if (setType == 'value')
        rElement.value(value);
      else
        rElement.text(value);
    }

    $(document).on('change', '[data-expression-key]', function (e: Event) {
      let key = (e.target as Element).getAttribute('data-expression-key');
      let elements = document.querySelectorAll('[data-expression*="' + key + '"]');

      Array.prototype.slice.call(elements).forEach((element: Element) => {
        let expression = element.getAttribute('data-expression');
        let expressionKeySurroundedByBrackets = /\[([^\]]*)\]/g;
        let expressionKeys = expression.match(expressionKeySurroundedByBrackets);
        let selectors = expressionKeys.map(x => 'expression-key'.asDataSelector(x.replace(/[\[\]]/g, '')));
        let values = selectors.map(x => getValue(document.querySelector(x) as HTMLElement));
        for (let i = 0; i < expressionKeys.length; i++) {
          expression = expression.replace(expressionKeys[i], values[i]);
        }
        let value = Function('return ' + expression)();
        setValue(element as HTMLElement, value);
      });
    });

    $(document).on('change', '[data-sum-key]', function (e: Event) {
      let key = (e.target as Element).getAttribute('data-sum-key');
      let keyElements = document.querySelectorAll('sum-key'.asDataSelector(key));
      let value = Array.prototype.slice.call(keyElements).reduce((total, element) => total + parseFloat(getValue(element as HTMLElement)), 0);

      let sumElement = document.querySelector('sum'.asDataSelector(key));
      setValue(sumElement as HTMLElement, value);
    });
  }
}